import type { Route } from "routes/route";

import { useAuthenticatedUser } from "hooks/useAuthenticatedUser";
import { useAuthorization } from "hooks/useAuthorization";
import { useCompany } from "hooks/useCompany";
import { useFeatureFlags } from "hooks/useFeatureFlags";

interface IResult {
  allowed: boolean;
  loading: boolean;
}

export const useRouteAccess = (route: Route): IResult => {
  const { user } = useAuthenticatedUser();
  const company = useCompany();
  const flags = useFeatureFlags();
  const { hasPermission, loading } = useAuthorization("company", company?.id);

  if (!user) return { allowed: false, loading: false };

  return {
    allowed: route.shouldRender({ company: company ?? undefined, flags, hasPermission, user }),
    loading: Boolean(flags.enableOpenFgaAuthorization && loading),
  };
};
